<template>
  <div class="grid grid-cols-2 col-gap-8">
    <template v-if="!currentUserIsWatcher">
      <template v-if="budgets.copy_available">
        <BaseButton theme="red" @click="copy" :loading="isCreating">
          {{ $t('copy') }}
        </BaseButton>
        <BaseButton theme="default" @click="create" :loading="isCreating">
          {{ $t('create') }}
        </BaseButton>
      </template>
      <template v-else>
        <BaseButton theme="red" @click="create" :loading="isCreating">
          {{ $t('create') }}
        </BaseButton>
      </template>
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "BudgetsNavCreate",
  components: {BaseButton},
  data() {
    return {
      isCreating: false,
    }
  },
  computed: {
    ...mapState('space/budgets', ['filters', 'budgets']),
    ...mapGetters('space', ['currentUserIsWatcher']),
  },
  methods: {
    ...mapActions('space/budgets', ['createBudget', 'copyBudget', 'getBudgets']),
    create() {
      const date = this.filters.date.split('-');
      const data = {
        space_id: this.$store.state.space.current_space.data.id,
        year: date[0],
        month: date[1]
      };
      this.isCreating = true;
      this.createBudget(data).then((res) => {
        if (res.body.success) {
          this.$toasted.success('Бюджет создан');
          this.getBudgets();
        } else {
          this.$toasted.error('Произошла ошибка')
        }
        this.isCreating = false;
      })
    },
    copy() {
      const date = this.filters.date.split('-');
      const data = {
        space_id: this.$store.state.space.current_space.data.id,
        year: date[0],
        month: date[1]
      };
      this.isCreating = true;
      this.copyBudget(data).then((res) => {
        if (res.body.success) {
          this.$toasted.success('Бюджет скопирован');
          this.getBudgets();
        } else {
          this.$toasted.error('Произошла ошибка')
        }
        this.isCreating = false;
      })
    },
  },
  i18n: {
    messages: {
      en: {
        copy: 'Copy',
        create: 'Create'
      },
      ru: {
        copy: 'Скопировать',
        create: 'Создать'
      },
    }
  }

}
</script>